import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/apiClient";
import i18n from "@/i18n";

const AuthContext = createContext(null);

// Apply the user's saved profile language ONLY when the user hasn't manually
// chosen a language on this device (manual choice writes rf_lang and wins).
function applyProfileLang(u) {
  if (u && u.language && !localStorage.getItem("rf_lang")) {
    i18n.changeLanguage(u.language);
  }
}

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("rf_token");
    if (!token) {
      setUser(false);
      setReady(true);
      return;
    }
    api
      .get("/auth/me")
      .then((r) => { setUser(r.data); applyProfileLang(r.data); })
      .catch(() => {
        localStorage.removeItem("rf_token");
        setUser(false);
      })
      .finally(() => setReady(true));
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("rf_token", data.access_token);
    setUser(data.user);
    applyProfileLang(data.user);
    return data.user;
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch (e) {}
    localStorage.removeItem("rf_token");
    setUser(false);
  };

  const can = (perm) => {
    if (!user) return false;
    if (user.role === "super_admin") return true;
    return (user.permissions || []).includes(perm);
  };

  return (
    <AuthContext.Provider value={{ user, ready, login, logout, setUser, can }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
